import { render } from "./FileProcessingDetails.vue?vue&type=template&id=665ce47b&scoped=true"
import script from "./FileProcessingDetails.vue?vue&type=script&lang=js"
export * from "./FileProcessingDetails.vue?vue&type=script&lang=js"

import "../assets/css/campaignDetail.css?vue&type=style&index=0&id=665ce47b&scoped=true&lang=css"
import "./FileProcessingDetails.vue?vue&type=style&index=1&id=665ce47b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665ce47b"]])

export default __exports__